// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ni-products-chips__skeleton{display:flex;gap:8px;margin:0 -4px 16px;padding:0 16px}@media only screen and (min-width:1264px){.ni-products-chips__skeleton{flex-wrap:wrap;margin:0 0 16px;padding:0}}.ni-products-chips__skeleton .v-skeleton-loader__button{border-radius:16px;flex:0 0 auto;height:30px;width:100px}@media only screen and (min-width:1264px){.ni-products-chips__skeleton .v-skeleton-loader__button{height:40px;width:120px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
